export default {"src":"/_next/static/media/SWTX.86861ec3.svg","height":18,"width":18};